import React, { useState, ChangeEvent, useEffect } from "react";
import { Alert, Box, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import {
  getUploadKeyAction,
  setUploadFileAction,
} from "../../../store/reducers/mmymSlice";
import { useSelector } from "react-redux";

interface ImageUploaderProps {
  defaultImage: string;
  onImageUpload: (image: string | null) => void;
  width?: number; // Dynamic width
  height?: number; // Dynamic height
  showUploadButton?: boolean; // Optional prop to control upload button visibility
  btnName?: string;
  page?: string;
}

const ImageUploader: React.FC<ImageUploaderProps> = ({
  defaultImage,
  onImageUpload,
  width,
  height,
  btnName,
  showUploadButton = false,
  page = "",
}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [imageError, setImageError] = useState("");
  const dispatch = useDispatch();
  const { userProfile,fileUploadModulePermission } = useSelector((state: any) => state.user);

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      console.log("file", file);
      if (file?.type?.includes("image/")) {
        if (file?.size > 5000000) {
          const size = file?.size / 1000;
          setImageError(
            `Filesize ${size} kb is too big, Maximum allowed is 5000 kb.`
          );
          setTimeout(() => {
            setImageError("");
          }, 3000);
        } else {
          const reader = new FileReader();
          reader.onloadend = () => {
            console.log("reader-", reader);
            const image = reader.result as string;
            if (file?.name) {
              dispatch(
                getUploadKeyAction({
                  fileName: `${page}/${file?.name}`,
                  fileType: file?.type,
                  body: file,
                  page,
                })
              );
            }
            setSelectedImage(image);
            dispatch(
              setUploadFileAction({
                url: image,
                key: "",
              })
            );
            onImageUpload(image);
          };
          reader.readAsDataURL(file);
        }
      } else if (file?.type) {
        setImageError(
          `You selected different format - ${file?.type}, Please select image only.`
        );
        setTimeout(() => {
          setImageError("");
        }, 3000);
      }
    }
  };
  useEffect(() => {
    if (selectedImage) {
      console.log("selectedImage", selectedImage);
    }
  }, [selectedImage]);
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      { (userProfile?.roles?.includes("TENANT") || userProfile?.roles?.includes("Owner") || fileUploadModulePermission?.create) && (
        <input
          accept="image/*"
          style={{ display: "none" }}
          id="raised-button-file"
          type="file"
          onChange={handleImageUpload}
        />
      )}
   

      <label htmlFor="raised-button-file" style={{ cursor: "pointer" }}>
        <img
          src={selectedImage || defaultImage}
          alt="upload"
          style={{
            width: `${width}px`,
            height: `${height}px`,
            marginTop: "10px",
            objectFit: "contain",
          }}
        />
      </label>
      {imageError && (
        <div style={{ padding: "0 20px" }}>
          <Alert severity={"error"}>{imageError}</Alert>
        </div>
      )}
      {showUploadButton &&
        (userProfile?.roles?.includes("TENANT") || userProfile?.roles?.includes("Owner") || fileUploadModulePermission?.create) && (
          <label htmlFor="raised-button-file">
            <Button
              sx={{ mt: 2, textTransform: "capitalize", padding: "4px 16px" }}
              variant="contained"
              component="span"
            >
              {btnName ? btnName : "Upload Image"}
            </Button>
          </label>
        )}
    </Box>
  );
};

export default ImageUploader;
